import angular from 'angular';

import Listing from '../listing';
import Browser from 'cars-ng-browser';

import component from './previousNext.component';
import service from './previousNext.service';

export default angular.module('vdp.previousNext', [
    Listing,
    Browser
])

.component('previousNext', component)
.service('previousNextService', service)

.name;
